import { useState } from 'react';
import { TariffChapterApiModel, TariffClassificationApiModel } from '~/lib/api/smartsend/types';
import Loading from '../../../../components/loading/Loading';
import { Expansion } from './Expansion';
import { TariffClassifiction } from './TariffClassifiction';
import { TariffCode } from './TariffCode';
import { P2GBox, P2GLink, P2GFade } from '@parcel2go/core-ui';

interface props {
  chapter: TariffChapterApiModel;
  getClassifications?: (code: string) => Promise<TariffClassificationApiModel[]>;
  selectCode: (code: string) => void;
  canSelect: boolean;
}

const TariffChapter: React.FC<props> = (props) => {
  const [classifications, setClassifications] = useState<TariffClassificationApiModel[]>(
    props.chapter.Classifications || []
  );
  const [loading, setLoading] = useState(false);

  function loadClassifications() {
    if (props.getClassifications) {
      setLoading(true);
      props.getClassifications(props.chapter.Code).then((x) => {
        setClassifications(x);
        setLoading(false);
      });
    }
  }

  return (
    <P2GBox>
      <P2GBox onClick={loadClassifications} p={1} bordered>
        <P2GBox>
          <P2GLink>{props.chapter.Name}</P2GLink>
        </P2GBox>
        <P2GBox pt={1}>
          <TariffCode selectable={false} code={props.chapter.Code} />
        </P2GBox>
      </P2GBox>
      {loading && <Loading />}
      {classifications.length > 0 && (
        <Expansion mt={1}>
          {classifications.map((x) => (
            <P2GBox mb={1} key={x.Id}>
              <P2GFade in>
                <TariffClassifiction
                  canSelect={props.canSelect}
                  selectCode={props.selectCode}
                  classifiction={x}
                  getClassifications={props.getClassifications}
                />
              </P2GFade>
            </P2GBox>
          ))}
        </Expansion>
      )}
    </P2GBox>
  );
};

export { TariffChapter };
